<ng1-profile-forms [selectedPerson]="selectedPerson"
                   [isOrganisationAdmin]="isOrganisationAdmin"
                   [canSaveForm]="canSaveForm"></ng1-profile-forms>
